import { Button, Typography, Modal, Icon } from '@safedns/skydns-ui-react-lib';

import sprite from '../../icons/sprite.svg';

import styles from '../../styles/deleteModal.module.scss';

const DeleteCollectionDialog = ({
  isOpen,
  modalStateHandler,
  name,
  children,
  onDelete,
}) => {
  return (
    <Modal
      title="Удалить коллекцию?"
      isOpen={isOpen}
      onClose={modalStateHandler}
      sx={{ width: 336 }}
    >
      <div className={styles['modal-content']}>
        <div className={styles['icon-wrapper']}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>
        <Typography
          sx={{
            paddingTop: 12,
            paddingBottom: 24,
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Вы уверены, что хотите удалить <br /> {name}?
        </Typography>
        <div className="button-grid">
          <Button
            variant="secondary"
            onClick={modalStateHandler}
            size="small"
            sx={{ width: '100%' }}
          >
            Отмена
          </Button>
          <Button
            variant="primary"
            onClick={onDelete}
            size="small"
            sx={{
              width: '100%',
              backgroundColor: '#F20D0D',
              color: '#FFF',
              borderColor: '#F20D0D',
            }}
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteCollectionDialog;
